export * from "../octagon-badge/octagon-geometry";
